import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

export interface CopyFromDepartmentRequest {
  destinationDepartmentId: number;
  copyGLCodes: boolean;
  copyMembers: boolean;
  copyDeletedGLCodes: boolean;
  copyDeletedMembers: boolean;
}

const useDepartmentCopyApi = (companyId: string, departmentId: number) => {
  const call = useCallback(
    async (body?: CopyFromDepartmentRequest) =>
      axiosInstance.post(api.copyFromDepartment(companyId, departmentId), body),
    [companyId, departmentId]
  );

  const { isLoading, execute } = useAsync(call, false, undefined);

  return {
    isLoading,
    copyFromDepartment: execute,
  };
};

export default useDepartmentCopyApi;
